import { render } from "./index.vue?vue&type=template&id=ec3b6d4a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=ec3b6d4a&lang=less&scoped=true"

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec3b6d4a"]])

export default __exports__